import styled from "styled-components";

const SettingHelpText = styled.div`
  font-size: 14px;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
`;

export default SettingHelpText;
